var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 46C43.9411 46 52 37.9411 52 28C52 18.0589 43.9411 10 34 10C24.0589 10 16 18.0589 16 28C16 37.9411 24.0589 46 34 46Z",
    fill: "#151515"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0969 28.3378V27.0543H34.4673V24.4247H33.1839V27.0543H30.5543V28.3378H33.1839V30.9674H34.4673V28.3378H37.0969ZM38.3804 21.8265C38.7352 21.8265 39.043 21.9569 39.3039 22.2178C39.5647 22.4787 39.6952 22.7865 39.6952 23.1413V32.2508C39.6952 32.6056 39.5647 32.9134 39.3039 33.1743C39.043 33.4352 38.7352 33.5656 38.3804 33.5656H29.2708C28.9056 33.5656 28.5926 33.4352 28.3317 33.1743C28.0813 32.9134 27.956 32.6056 27.956 32.2508V23.1413C27.956 22.7865 28.0813 22.4787 28.3317 22.2178C28.5926 21.9569 28.9056 21.8265 29.2708 21.8265H38.3804Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_1384",
    x: 0.347824,
    y: 0.608694,
    width: 67.3044,
    height: 67.3044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.26087
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.82609
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.262745 0 0 0 0 0.92549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_1384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_1384",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.38a8518b10c9b752fb152e1b8f2702cd.svg";
export { ForwardRef as ReactComponent };